let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kb8GE")).then(() => parcelRequire('lQBzA'));